module.exports = __webpack_public_path__ + "assets/menu-info-icon-2a66ec.svg";